module.exports = __webpack_public_path__ + "media/components/outside-promo-page/static/mobile-d9348764276a534f782dcd47f7f6e896.webp";